// extracted by mini-css-extract-plugin
export default {"root":"ExplorerWin98_root__6ZJw8","container":"ExplorerWin98_container__gzJb5","menu":"ExplorerWin98_menu__L-6E2","content":"ExplorerWin98_content__scqpv"};